export const platforms = [
    {
        "value": "gatefi",
        "label": "GateFi",
        "image": "https://static.uniramp.io/cefi/gateway/gatefi.png"
    },
    {
        "value": "mercuryo",
        "label": "Mercuryo",
        "image": "https://static.uniramp.io/cefi/gateway/mercuryo.png"
    },
    {
        "value": "onramp_money",
        "label": "Onramp Money",
        "image": "https://static.uniramp.io/cefi/gateway/onramp_money.png"
    },
    {
        "value": "sandbox",
        "label": "Sandbox",
        "image": "https://static.uniramp.io/cefi/gateway/sandbox.png"
    },
    {
        "value": "transak",
        "label": "Transak",
        "image": "https://static.uniramp.io/cefi/gateway/transak.png"
    },
    {
        "value": "transfi",
        "label": "TransFi",
        "image": "https://static.uniramp.io/cefi/gateway/transfi.png"
    }
]

export const paymentMethods = [
    {
        "value": "alfamart",
        "label": "Alfamart",
        "image": "https://static.uniramp.io/cefi/payment/alfamart.png"
    },
    {
        "value": "apple_pay",
        "label": "Apple Pay",
        "image": "https://static.uniramp.io/cefi/payment/apple_pay.png"
    },
    {
        "value": "astropay",
        "label": "AstroPay",
        "image": "https://static.uniramp.io/cefi/payment/astropay.png"
    },
    {
        "value": "bank_transfer",
        "label": "Bank Transfer",
        "image": "https://static.uniramp.io/cefi/payment/bank_transfer.png"
    },
    {
        "value": "bpi",
        "label": "BPI",
        "image": "https://static.uniramp.io/cefi/payment/bpi.png"
    },
    {
        "value": "cash_app",
        "label": "Cash App",
        "image": "https://static.uniramp.io/cefi/payment/cash_app.png"
    },
    {
        "value": "credit_card",
        "label": "Credit Card",
        "image": "https://static.uniramp.io/cefi/payment/credit_card.png"
    },
    {
        "value": "dana",
        "label": "Dana",
        "image": "https://static.uniramp.io/cefi/payment/dana.png"
    },
    {
        "value": "duitnow",
        "label": "DuitNow",
        "image": "https://static.uniramp.io/cefi/payment/duitnow.png"
    },
    {
        "value": "enets",
        "label": "eNETS",
        "image": "https://static.uniramp.io/cefi/payment/enets.png"
    },
    {
        "value": "fps",
        "label": "FPS",
        "image": "https://static.uniramp.io/cefi/payment/fps.png"
    },
    {
        "value": "fpx",
        "label": "FPX",
        "image": "https://static.uniramp.io/cefi/payment/fpx.png"
    },
    {
        "value": "gcash",
        "label": "GCash",
        "image": "https://static.uniramp.io/cefi/payment/gcash.png"
    },
    {
        "value": "google_pay",
        "label": "Google Pay",
        "image": "https://static.uniramp.io/cefi/payment/google_pay.png"
    },
    {
        "value": "grabpay",
        "label": "GrabPay",
        "image": "https://static.uniramp.io/cefi/payment/grabpay.png"
    },
    {
        "value": "instapay",
        "label": "InstaPay",
        "image": "https://static.uniramp.io/cefi/payment/instapay.png"
    },
    {
        "value": "mobile_money",
        "label": "Mobile Money",
        "image": "https://static.uniramp.io/cefi/payment/mobile_money.png"
    },
    {
        "value": "ovo",
        "label": "OVO",
        "image": "https://static.uniramp.io/cefi/payment/ovo.png"
    },
    {
        "value": "payvalue",
        "label": "Payvalue",
        "image": "https://static.uniramp.io/cefi/payment/payvalue.png"
    },
    {
        "value": "paymaya",
        "label": "PayMaya",
        "image": "https://static.uniramp.io/cefi/payment/paymaya.png"
    },
    {
        "value": "paynow",
        "label": "PayNow",
        "image": "https://static.uniramp.io/cefi/payment/paynow.png"
    },
    {
        "value": "pix",
        "label": "Pix",
        "image": "https://static.uniramp.io/cefi/payment/pix.png"
    },
    {
        "value": "promptpay",
        "label": "PromptPay",
        "image": "https://static.uniramp.io/cefi/payment/promptpay.png"
    },
    {
        "value": "sepa_instant",
        "label": "SEPA Instant",
        "image": "https://static.uniramp.io/cefi/payment/sepa_instant.png"
    },
    {
        "value": "shopeepay",
        "label": "ShopeePay",
        "image": "https://static.uniramp.io/cefi/payment/shopeepay.png"
    },
    {
        "value": "tiger_pay",
        "label": "Tiger Pay",
        "image": "https://static.uniramp.io/cefi/payment/tiger_pay.png"
    },
    {
        "value": "upi",
        "label": "UPI",
        "image": "https://static.uniramp.io/cefi/payment/upi.png"
    },
    {
        "value": "viettelpay",
        "label": "ViettelPay",
        "image": "https://static.uniramp.io/cefi/payment/viettelpay.png"
    },
    {
        "value": "zalopay",
        "label": "ZaloPay",
        "image": "https://static.uniramp.io/cefi/payment/zalopay.png"
    }
]